import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { withRouter } from 'react-router';
import FCLink from '../../../components/fc_link/fc_link';
import Slug from '../../../components/slug/slug';

/*
import isEmpty from 'lodash/isEmpty';
import extend from 'lodash/extend';
import Ad from '../../../components/ad/ad';
import Slug from '../../../components/slug/slug';
*/

import NotFound from '../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../components/loading_spinner/loading_spinner';

// eslint-disable-next-line
class CompanyIndexPage extends Component {
  constructor() {
    super();
    this.group = this.group.bind(this);
  }

  group(name) {
    return (
      <section key={name}>
        <FCLink to={`/company/${name}/1`}>{name}</FCLink>
        <span>
          {get(this.props, `companyIndexGroups[${name}]`, []).join(', ')}
        </span>
      </section>
    );
  }
  render() {
    if (this.props.status === 404) {
      return (
        <section className="tag-page">
          <article className="tag-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    if (this.props.companyIndexPage.isLoading) {
      return (
        <section className="company-page">
          <article className="company-page__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }

    /*

    const {
      companyIndexData,
      companyIndexNextData
    } = this.props;

    const adData = get(this.props, 'companyIndexPage.ads');
    const combinedAdModel = extend({},
      { baseConfig: get(adData, 'config.baseConfig') },
      { definitions: get(adData, 'config.definitions') },
      { model: get(adData, 'model') }
    );

    const pgTitle = 'company index';
    const section = get(this.props, 'match.params.section');
    const page = Number(get(this.props, 'match.params.page'));
    const nextPage = page && !isEmpty(companyIndexNextData) ? String(page + 1) : null;
    const prevPage = page > 1 ? String(page - 1) : null;

*/
    return (
      <section className={`tag-page`}>
        <section className="page-title">
          <Slug slugName={`Company Index`} className="category-page" />
        </section>
        <section>
          {Object.keys(this.props.companyIndexGroups).map(this.group)}
        </section>
      </section>
    );
  }
}

function mapStateToProps(state = {}) {
  return {
    config: state.config || {},
    status: state.status.code,
    companyIndexData: get(state, 'companyIndex.data', {}),
    companyIndexGroups: get(state, 'companyIndexGroups.data.rows', {}),
    companyIndexNextData: get(state, 'companyIndexNext.data', {}),
    companyIndexPage: get(state, 'companyIndexPage', {})
  };
}

CompanyIndexPage.propTypes = {
  /* eslint-disable */
  status: PropTypes.number,
  companyIndexData: PropTypes.shape({

  }),
  companyIndexGroups: PropTypes.arrayOf(PropTypes.shape({})),
  companyIndexPage: PropTypes.shape({
    ads: PropTypes.object,
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string
  })
  /* eslint-enable */
};

CompanyIndexPage.defaultProps = {
  /* eslint-disable */
  status: PropTypes.number,
  companyIndexData: PropTypes.shape({

  }),
  companyIndexGroups: PropTypes.shape({

  }),
  companyIndexNextData: PropTypes.shape({

  }),
  companyIndexPage: PropTypes.shape({
    ads: PropTypes.object,
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string
  })
  /* eslint-enable */
};

export default withRouter(connect(mapStateToProps)(CompanyIndexPage));



// WEBPACK FOOTER //
// ./src/views/containers/pages/company_index_page/company_index_page.js